import { Link } from 'react-router-dom';
import { cases } from '@/mocks/cases';
import SectionHeading from '@/components/base/SectionHeading';
import StatusBadge from '@/components/base/StatusBadge';

const RumorSection = () => {
  const verified = cases.filter((item) => item.timeline.some((node) => node.type === '辟谣'));

  return (
    <section id="rumor" className="scroll-mt-24 border-b border-background-200 bg-background-100">
      <div className="layout-shell py-12 md:py-16">
        <SectionHeading
          eyebrow="Verification Desk"
          title="辟谣专区"
          desc="传得最快的不一定最接近事实。这里汇总已经被核实的说法，以及仍在等待更多证据的疑点。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-3">
          {verified.map((item) => {
            const node = item.timeline.find((n) => n.type === '辟谣');
            return (
              <article key={item.id} className="flex flex-col rounded-lg border border-secondary-200 bg-background-50 p-5">
                <div className="flex items-center gap-2 text-secondary-700">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100">
                    <i className="ri-shield-check-line" aria-hidden="true" />
                  </span>
                  <span className="text-xs font-label font-medium uppercase tracking-wider">已核实</span>
                </div>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">{node?.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{node?.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-secondary-200 pt-3">
                  <span className="text-xs text-foreground-500">{node?.date}</span>
                  <Link to={`/case/${item.id}`} className="inline-flex items-center gap-1 text-xs font-medium text-primary-700 transition-colors hover:text-primary-800">
                    查看完整档案
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </Link>
                </div>
              </article>
            );
          })}

          <article className="flex flex-col rounded-lg border border-accent-200 bg-accent-50 p-5">
            <div className="flex items-center gap-2 text-accent-700">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100">
                <i className="ri-search-eye-line" aria-hidden="true" />
              </span>
              <span className="text-xs font-label font-medium uppercase tracking-wider">待核实清单</span>
            </div>
            <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">还在等证据的说法</h3>
            <ul className="mt-3 flex-1 space-y-2.5">
              {cases
                .filter((item) => item.status === '待核实')
                .map((item) => (
                  <li key={item.id} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-question-line mt-0.5 text-accent-600" aria-hidden="true" />
                    <Link to={`/case/${item.id}`} className="transition-colors hover:text-primary-700">
                      {item.title}
                    </Link>
                  </li>
                ))}
            </ul>
            <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-accent-200 pt-3">
              <StatusBadge status="待核实" />
              <span className="text-xs text-foreground-500">更多证据出现后会第一时间更新</span>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default RumorSection;